import React from 'react';
import { WDHLocationsSpot, ListPaginated, GoogleMap, Search, FilterList, SearchFilterButton } from '../../../../wdh-feature/wdh-locations-spot';
var locationsSpot = new WDHLocationsSpot();

// DESKTOP LAYOUT
locationsSpot.addDesktopView(/*#__PURE__*/React.createElement(ListPaginated, {
  key: "list",
  header: [/*#__PURE__*/React.createElement(Search, {
    key: "search",
    footer: [/*#__PURE__*/React.createElement(SearchFilterButton, {
      key: "sfb"
    })]
  })]
}));
locationsSpot.addDesktopView(/*#__PURE__*/React.createElement(GoogleMap, {
  key: "map"
}));

// MOBILE LAYOUT

locationsSpot.addMobileView(/*#__PURE__*/React.createElement(FilterList, {
  key: "filterList"
}));
locationsSpot.addMobileView(/*#__PURE__*/React.createElement(Search, {
  key: "search"
}));
locationsSpot.addMobileView(/*#__PURE__*/React.createElement(GoogleMap, {
  key: "map"
}));
locationsSpot.addMobileView(/*#__PURE__*/React.createElement(ListPaginated, {
  key: "list"
}));
locationsSpot.run();